var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9679 21.4367L1.84968 7.21678C0.0441071 6.31393 -0.106357 7.59297 0.0441071 8.34535C1.54875 13.0101 4.87401 22.8813 6.13791 25.0481C7.71778 27.7567 14.7144 28.2081 16.0685 28.2081C17.4227 28.2081 21.9366 27.0796 24.645 25.2739C26.8117 23.8293 25.0964 22.1139 23.9679 21.4367Z",
    fill: "#54A3DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2869 0.435945L7.94637 18.7187C5.46371 20.2657 5.23802 23.0076 5.91511 24.5876C6.5922 26.1676 10.2033 28.199 19.6826 28.4247C27.266 28.6053 30.0652 26.3919 32.5478 22.5555C35.0305 16.4612 40.1764 3.32529 39.9958 1.33901C39.8177 -0.619789 38.2344 0.04071 37.3248 0.420151L37.2869 0.435945Z",
    fill: "#27AAE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2491 21.4141C25.3775 22.0912 27.0927 23.8065 24.9268 25.251C22.2185 27.0567 17.7038 28.1855 16.3497 28.1855C16.1805 28.1855 15.9233 28.1787 15.5997 28.1611C9.33549 27.5167 6.75777 25.8985 6.19634 24.5889C5.51926 23.0089 5.74503 20.2667 8.22759 18.7197L14.2344 14.9766L24.2491 21.4141Z",
    fill: "#1083C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectica);
export default __webpack_public_path__ + "static/media/Selectica.3558cbbe66df5966d81b4679c21f612a.svg";
export { ForwardRef as ReactComponent };